import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import PropTypes from 'prop-types';

const changes = (count) => `${count} unsaved ${count === 1 ? 'change' : 'changes'}`;

// Shown when leaving the page, or switching "Pricing for", with unsaved changes.
export const LeaveWithoutSavingDialog = ({ open, unsavedCount, onStay, onLeave }) => (
  <Dialog open={open} onClose={onStay}>
    <DialogTitle>Leave without saving?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {`You have ${changes(unsavedCount)}. They will be lost if you leave this pricing.`}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onStay}>Stay</Button>
      <Button variant='contained' color='error' onClick={onLeave}>
        Leave
      </Button>
    </DialogActions>
  </Dialog>
);

LeaveWithoutSavingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  unsavedCount: PropTypes.number.isRequired,
  onStay: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
};

// The "are you sure?" before Discard changes throws edits and added rows away.
export const DiscardChangesDialog = ({ open, unsavedCount, onKeepEditing, onDiscard }) => (
  <Dialog open={open} onClose={onKeepEditing}>
    <DialogTitle>{`Discard ${changes(unsavedCount)}?`}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Edited cells go back to their saved values and added rows are removed.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onKeepEditing}>Keep editing</Button>
      <Button variant='contained' color='error' onClick={onDiscard}>
        Discard
      </Button>
    </DialogActions>
  </Dialog>
);

DiscardChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  unsavedCount: PropTypes.number.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
};
